import React from "react";
import "./Navbar.css";
import logo from "../Assets/logo.webp";
import { useAuth } from "../../Context/AuthContext";

const Navbar = () => {
  const { isAuthenticated, user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="navbar">
      <div className="nav-logo">
        <img src={logo} alt="" />
        <p>Fashion Spice</p>
      </div>
      <ul className="nav-menu">
        {isAuthenticated ? (
          <>
            <li>Welcome, {user?.name || user?.email || "Admin"}</li>
            <li onClick={handleLogout} style={{ cursor: "pointer" }}>
              Logout
            </li>
          </>
        ) : (
          <li>Admin Panel</li>
        )}
      </ul>
    </div>
  );
};

export default Navbar;
